import React, { useState, useEffect } from 'react';
import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';
import { useElements, useStripe } from '@stripe/react-stripe-js';
import { toast } from 'react-toastify';
import { getSetupIntentByIdUrl } from '../../../constants/webapi/user';
import *  as axios from 'axios';
import $ from 'jquery';

import { LoadingState } from '../../loadingState';
import {ToasterConfigurations} from '../../../constants/toasterText/configurations';
import {HandlePaymentMethodsError} from '../../../constants/toasterText/paymentMethodErrors';

import { addPaymentMethod } from '../../../actions/user-api';


import * as R from 'ramda';
import { useDispatch } from 'react-redux';

import iconCredit from '../../../assets/images/svg/142-credit-salary.svg';
import iconCreditBack from '../../../assets/images/svg/142-virement.svg';

export const AddCreditCardForm = ({ paymentMethod, formRef, user, formId, resetModal, setIsSaving }) => {
    let dispatch = useDispatch();
    const stripe = useStripe();
    const elements = useElements();
    const [setupIntent, setSetupIntent] = useState(undefined);
    const [visibleSide, setVisibleSide] = useState('front');
    const [isLoadingSetupIntent, setIsLoadingSetupIntent] = useState(false);
    const [formElementsComplete, setformElementsComplete] = useState({ cardNumber: false, expirationDate: false, cvcCode: false});

    let icon = iconCredit;
    if (visibleSide === 'front') {
        icon = iconCredit;
    } else {
        icon = iconCreditBack;
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (!stripe || !elements) {
            // Stripe.js has not loaded yet. Make sure to disable
            // form submission until Stripe.js has loaded.
            return;
        }
        if(formElementsComplete.cardNumber !== true || formElementsComplete.expirationDate !== true || formElementsComplete.cvcCode !== true){
            return;
        }
        setIsSaving(true);
        //const cardElement = elements.getElement(CardElement);
        const cardNumberElement = elements.getElement(CardNumberElement);

        await axios.get(getSetupIntentByIdUrl(user.id))
            .then(async (response) => {
                const setupIntendId = response.data;
                const result = await stripe.confirmCardSetup(setupIntendId, {
                    payment_method: {
                        type: 'card',
                        card: cardNumberElement,
                    }
                });
                if (result.error) {
                    const errorMessage = HandlePaymentMethodsError(result.error);
                    toast.error(errorMessage, ToasterConfigurations);
                    setIsSaving(false);
                } else {
                    await dispatch(addPaymentMethod(user, result.setupIntent.payment_method))
                        .then(() => {
                            setIsSaving(false);
                            $('.modal').modal("hide");
                            resetModal();
                        });
                }
            })
            .catch((error) => {
                console.log(error.response);
            });

    };

    if (isLoadingSetupIntent) {
        return (<LoadingState />);
    }

    return (
        <form onSubmit={handleSubmit} ref={formRef} id={formId}>
            <div className="row gx-2">
                <div className="col-auto col-xl-3 flex-column align-items-center">
                    <img className="img-fluid w-avatar m-auto" src={icon} alt="Assist@" />
                </div>
                <div className="col">
                    <div className="form-group mb-2">
                        <label className="h6 font-weight-bolder my-auto" htmlFor="cartenum">Numéro de carte</label>
                        {
                            R.isNil(paymentMethod) ?
                                <CardNumberElement id="cartenum"
                                    onFocus={
                                        () => {
                                            if (!R.isNil(setVisibleSide)) {
                                                setVisibleSide('front');
                                            }
                                        }
                                    }
                                    onChange={(e) => setformElementsComplete({...formElementsComplete, cardNumber: e.complete})}
                                    options={{
                                        style: {
                                            base: {
                                                color: '#26262e',
                                                lineHeight: '20px',
                                                fontSize: '15px',
                                                fontSmoothing: 'antialiased',
                                                '::placeholder': {
                                                    color: '#9e9eac',
                                                },
                                            },
                                            invalid: {
                                                iconColor: '#B81412',
                                                color: '#B81412',
                                            }
                                        },
                                        classes: {
                                            base: 'form-control h-auto',
                                            complete: 'is-valid',
                                            invalid: 'bg-alert-danger border-none',
                                            empty: ''
                                        },
                                        iconStyle: 'default'
                                    }} />
                                :
                                <input type="text" className="form-control h-auto" value={"•••• •••• •••• " + paymentMethod.number} disabled />

                        }

                    </div>
                    <div className="form-row gy-1">
                        <div className="col form-group">
                            <label className="h6 font-weight-bolder my-auto" htmlFor="date">Date d'expiration</label>
                            {
                                R.isNil(paymentMethod) ?
                                    <CardExpiryElement id="date"
                                        onFocus={
                                            () => {
                                                if (!R.isNil(setVisibleSide)) {
                                                    setVisibleSide('front');
                                                }
                                            }
                                        }
                                        onChange={(e) => setformElementsComplete({...formElementsComplete, expirationDate: e.complete})}
                                        options={{
                                            style: {
                                                base: {
                                                    color: '#26262e',
                                                    lineHeight: '20px',
                                                    fontSize: '15px',
                                                    fontSmoothing: 'antialiased',
                                                    '::placeholder': {
                                                        color: '#9e9eac',
                                                    },
                                                },
                                                invalid: {
                                                    iconColor: '#B81412',
                                                    color: '#B81412',
                                                }
                                            },
                                            classes: {
                                                base: 'form-control h-auto',
                                                complete: 'is-valid',
                                                invalid: 'bg-alert-danger border-none',
                                                empty: ''
                                            },
                                            iconStyle: 'default'
                                        }}
                                    />
                                    :
                                    <input type="text" className="form-control h-auto" value={paymentMethod.expMonth + " / " + paymentMethod.expYear.toString().substring(2)} disabled />

                            }

                        </div>
                        <div className="col form-group">
                            <label className="h6 font-weight-bolder my-auto" htmlFor="cvc">Cryptogramme</label>
                            {
                                R.isNil(paymentMethod) ?
                                    <CardCvcElement id="cvc"
                                        onFocus={
                                            () => {
                                                if (!R.isNil(setVisibleSide)) {
                                                    setVisibleSide('back');
                                                }
                                            }
                                        }
                                        onChange={(e) => setformElementsComplete({...formElementsComplete, cvcCode: e.complete})}
                                        options={{
                                            style: {
                                                base: {
                                                    color: '#26262e',
                                                    lineHeight: '20px',
                                                    fontSize: '15px',
                                                    fontSmoothing: 'antialiased',
                                                    '::placeholder': {
                                                        color: '#9e9eac',
                                                    },
                                                },
                                                invalid: {
                                                    iconColor: '#B81412',
                                                    color: '#B81412',
                                                }
                                            },
                                            classes: {
                                                base: 'form-control h-auto',
                                                complete: 'is-valid',
                                                invalid: 'bg-alert-danger border-none',
                                                empty: ''
                                            },
                                            iconStyle: 'default'
                                        }}
                                    />
                                    :
                                    <input type="text" className="form-control h-auto" value="•••" disabled />

                            }

                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
};